import {
  AppBar,
  Container,
  Grid,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
  useScrollTrigger,
} from "@mui/material";
import { Box } from "@mui/system";
import FoodCard from "components/FoodCard";
import RestaurantContainer from "components/RestaurantContainer";
import TrendCard from "components/TrendCard";
import { IProductCategory } from "types/Product";
import { Colors, Fonts } from "helpers/Consts";
import { useQueryPlace } from "services/api/queries/useQueryPlace";
import { useQueryProduct } from "services/api/queries/useQueryProduct";
import {
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react";
import { useSearchParams } from "react-router-dom";
import { NavItem, NavMenu } from "@mui-treasury/components/menu/navigation";
import { useLineNavigationMenuStyles } from "@mui-treasury/styles/navigationMenu/line";
import {
  NonTrendFoodMenuItemSkeleton,
  TrendFoodMenuItemSkeleton,
  filterCategoriesWithNoProductsInSearchResult,
  filterCategoriesOnlyNonTrend,
  filterCategoriesOnlyTrend,
  filterProductsBySearch
} from "../../components/FoodMenu";
import { IShoppingBagData, ISingleShoppingBagResponse } from "../../types/ShoppingBag";
import { UseQueryResult } from "react-query";

type Props = {
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
}

function Cardapio({shoppingBagQuery} :Props) {
  // useState categorias
  const [categorias, setCategorias] = useState<Array<IProductCategory>>();

  // GET place_id from URL
  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");

  // Query and Redux to Places
  const  apiPlace = useQueryPlace(Number(placeId) ? Number(placeId) : 445057);

  // Get Api Product
  const apiProduct = useQueryProduct(
    Number(placeId) ? Number(placeId) : 445057
  );

  useEffect(() => {
    if (apiProduct.data?.success) {
      setCategorias(apiProduct.data?.data);
    }
  }, [apiProduct.data]);

  const ref = useRef<HTMLDivElement>(null);
  const [catRef, setCatRef] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleButtonClick = (title: string) => {
    let y: number | undefined;
    setTimeout(() => {
      setCatRef(title);
      y = ref.current?.offsetTop!;
    }, 100);
    setTimeout(() => {

      window.scrollTo({
        top: Number(y) - 140,
        left: 0,
        behavior: "smooth",
      });
    }, 200);
    setTimeout(() => {
      y = ref.current?.offsetTop!;
      window.scrollTo({
        top: Number(y) - 140,
        left: 0,
        behavior: "smooth",
      });
    }, 400)

  };

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 15, // Bug #5662
  });
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  return (
    <Box>
      <Container
        sx={{  height: "100vh", marginTop: { xs: "0px", md: "70px" } }}
        maxWidth="lg"
      >
        <RestaurantContainer place={apiPlace.data} />

        <Box>
          <AppBar
            color="inherit"
            sx={{
              position: trigger && matches ? "fixed" : "sticky",
              width: "100%",
              zIndex: 1200,
            }}
            elevation={0}
          >
            <NavMenu
              gutter={"8px"}
              useStyles={useLineNavigationMenuStyles}
              style={{ paddingBottom: "16px" }}
            >
              {categorias &&
                categorias?.map((categ) => (
                  <NavItem
                    key={categ.title}
                    onClick={() => {
                      handleButtonClick(categ.title);
                    }}
                    style={{
                      color: Colors.baseTextColor,
                    }}
                  >
                    {categ.title}
                  </NavItem>
                ))}
            </NavMenu>
            <TextField
              id="outlined-search"
              label="Procure por um item"
              type="search"
              onChange={handleChange}
              value={searchTerm}
              fullWidth
              sx={{
                marginTop: trigger && matches ? "8px" : "12px",
                width: trigger && matches ? "90%" : "100%",
                marginLeft: trigger && matches ? '10px' : '0px',
                marginBottom: '12px'
              }}
            />
          </AppBar>

        </Box>

        {categorias ? (
          categorias
            ?.filter(filterCategoriesOnlyTrend)
            .filter(filterCategoriesWithNoProductsInSearchResult(searchTerm))
            .map((dest) => (
              <Box
                sx={{ marginTop: 1 }}
                key={dest.title}
                id={dest.title}
                ref={dest.title === catRef ? ref : null}
              >
                <Typography
                  variant="h5"
                  color="black"
                  fontFamily={Fonts.fontStyleBold}
                  style={{ fontWeight: 600 }}

                  borderLeft={`1px solid ${Colors.orangePrimary}`}
                  borderBottom={`2px solid ${Colors.orangePrimary}`}
                  paddingLeft={'10px'}
                  paddingTop={'3px'}
                  paddingBottom={'3px'}
                  borderRadius={'0 0 6px 6px'}
                  marginBottom={'3px'}
                  marginTop={'8px'}
                  marginLeft={'-3px'}
                >
                  {!searchTerm && dest.title}
                </Typography>
                <Grid container spacing={3} padding={'6px 6px 6px 9px'}>
                  <NavMenu
                    gutter={"8px"}
                    useStyles={useLineNavigationMenuStyles}
                    style={{ marginTop: "16px" }}
                  >
                    {dest.data
                      .filter(filterProductsBySearch(searchTerm))
                      .map((product) => (
                        <Fragment key={product.id}>
                          <NavItem
                            style={{
                              color: Colors.baseTextColor,
                            }}
                          >
                            <TrendCard product={product} shoppingBagQuery={shoppingBagQuery} placeInfo={apiPlace?.data?.data}/>
                          </NavItem>
                        </Fragment>
                      ))}
                  </NavMenu>
                </Grid>
              </Box>
            ))
        ) : <TrendFoodMenuItemSkeleton/>
        }
        {categorias ? (
          categorias
            ?.filter(filterCategoriesOnlyNonTrend)
            .filter(filterCategoriesWithNoProductsInSearchResult(searchTerm))
            .map((cat) => (
              <Box
                sx={{ marginTop: 3 }}
                key={cat.title}
                id={cat.title}
                ref={cat.title === catRef ? ref : null}
              >
                {!searchTerm && <Typography
                  variant="h5"
                  color="black"
                  style={{ fontWeight: 600}}
                  borderLeft={`1px solid ${Colors.orangePrimary}`}
                  borderBottom={`2px solid ${Colors.orangePrimary}`}
                  paddingLeft={'10px'}
                  paddingTop={'3px'}
                  paddingBottom={'3px'}
                  borderRadius={'0 0 6px 6px'}
                  marginBottom={'3px'}
                  marginTop={'8px'}
                  marginLeft={'-3px'}
                >
                  {cat.title}
                </Typography>}
                <Grid container spacing={3} padding={'6px 6px 6px 9px'}>
                  {cat.data
                    .filter(filterProductsBySearch(searchTerm))
                    .map((item) => (
                      <Grid item lg={6} md={6} sm={6} xs={12} key={item.id}>
                        <FoodCard product={item} shoppingBagQuery={shoppingBagQuery} placeInfo={apiPlace?.data?.data}/>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            ))
        ) : <NonTrendFoodMenuItemSkeleton />
        }
        <Box sx={{ paddingBottom: { xs: 15, md: 0 } }} />
      </Container>
    </Box>
  );
}

export default Cardapio;
